import PropTypes from 'prop-types';
import { NavLink as RouterLink } from 'react-router-dom';
import { Box, List, ListItemIcon, ListItemText } from '@mui/material';
import { StyledNavItem, styles } from './styles';
import useUser from 'hooks/helpers/useUser';
import MyTooltip from 'components/MyTooltip';
import { USER_ROLES } from 'data/user/user.constants';

function resolveUserRole(user) {
  const role = user?.data?.data?.role ?? user?.data?.role ?? user?.role;
  if (role === undefined || role === null) {
    return USER_ROLES.ADMIN;
  }
  return role;
}

NavSection.propTypes = {
  data: PropTypes.array,
  openNav: PropTypes.bool
};

export default function NavSection({ openNav, data = [], ...other }) {
  const user = useUser();
  const role = resolveUserRole(user);

  return (
    <Box {...other} sx={{ width: '100%', ...other.sx }}>
      <List disablePadding sx={{ p: 1, width: '100%' }}>
        {data.map((item) => {
          if (!item.roles.includes(role)) {
            return null;
          }
          return <NavItem openNav={openNav} key={item.path} item={item} />;
        })}
      </List>
    </Box>
  );
}

NavItem.propTypes = {
  item: PropTypes.object,
  openNav: PropTypes.bool
};

function NavItem({ item, openNav }) {
  const { title, path, icon, info } = item;

  return (
    <StyledNavItem
      component={RouterLink}
      to={path}
      sx={{
        '&.active': {
          color: 'text.primary',
          bgcolor: 'action.selected',
          fontWeight: 'fontWeightBold'
        }
      }}>
      {!openNav ? (
        <MyTooltip title={title} placement="right">
          <ListItemIcon sx={styles.listItem}>{icon && icon}</ListItemIcon>
        </MyTooltip>
      ) : (
        <ListItemIcon sx={styles.listItem}>{icon && icon}</ListItemIcon>
      )}

      {openNav && <ListItemText disableTypography primary={title} />}

      {info && info}
    </StyledNavItem>
  );
}
